import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { Auth } from "auth";
import DashboardAuthorization from "components/DashboardAuthorization/DashboardAuthorization";
import AppContext from "context/AppContext";
import routes from "dashboard-configs/routesConfig";
import React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { store } from "redux/store";
import { QueryParamProvider } from "use-query-params";
import App from "./App";
import i18n from "./i18n";
import "./index.scss";
import "react-toastify/dist/ReactToastify.css";

const queryClient = new QueryClient({});

Sentry.init({
  dsn: "https://20cc58b2a53746da9363a0e7b8580fc0@o422403.ingest.sentry.io/5778279",
  integrations: [new Integrations.BrowserTracing()],
  enabled: process.env.NODE_ENV === "production",

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  // <React.StrictMode>
  <AppContext.Provider
    value={{
      routes,
    }}
  >
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Auth>
          <Router>
            <QueryParamProvider ReactRouterRoute={Route}>
              <DashboardAuthorization>
                <I18nextProvider i18n={i18n}>
                  <App />
                </I18nextProvider>
              </DashboardAuthorization>
            </QueryParamProvider>
          </Router>
        </Auth>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </AppContext.Provider>,
  // </React.StrictMode>,
  document.getElementById("root")
);
